import { type SiteResponse } from '@on3/api';
import { On3IconForum } from '@on3/icons';
import { Link } from '@on3/ui-lib/components/Link';
import { FanSiteAvatar } from '@public/components/Image/FanSiteAvatar';
import clsx from 'clsx';

import styles from './FanSiteItem.module.scss';

interface IFanSiteItem {
  data?: SiteResponse;
  isFavoriteTeam?: boolean;
}

export const FanSiteItem = ({ data, isFavoriteTeam }: IFanSiteItem) => {
  const { organization, url = '/', siteName, forum, key } = data || {};
  const isSoftballAmerica = key === 401;
  const name = isSoftballAmerica ? 'Softball' : organization?.name ?? '';

  const siteUrl = url?.endsWith('/') ? url : url + '/' || '/';

  const asset = data?.organization?.defaultAssetRes || data?.alternateAvatar;

  return (
    <li
      className={clsx(styles.fanitem, {
        [styles.favoriteTeam]: isFavoriteTeam,
      })}
    >
      <Link className={styles.logo} href={siteUrl}>
        <FanSiteAvatar asset={asset} height={30} width={30} />
      </Link>
      <Link className={styles.fanWrapper} href={siteUrl}>
        <span className={styles.fanText}>{siteName}</span>
        <span className={styles.team}>{name}</span>
      </Link>
      {forum?.url && (
        <a className={styles.forum} href={forum?.url}>
          <On3IconForum height={14} width={14} />
          <span className="sr-only">Go to Boards</span>
        </a>
      )}
    </li>
  );
};
